/**
 * NOTE: This is generated file any changes to it can be overwritten at some point
 */
import React from 'react';

import { createSvgIcon } from '../utils';

const MenuIcon = /*#__PURE__*/ createSvgIcon(
  'MenuIcon',
  {
    ltr: {
      large: ({ id }) => (
        <>
          <path
            d="M3.75 14.5a.728.728 0 01-.534-.214.72.72 0 01-.216-.532c0-.21.072-.39.216-.535A.72.72 0 013.75 13h12.5c.212 0 .39.072.534.214a.72.72 0 01.216.532c0 .21-.072.39-.216.535a.72.72 0 01-.534.219H3.75zm0-3.75a.728.728 0 01-.534-.214.72.72 0 01-.216-.532c0-.21.072-.39.216-.535a.72.72 0 01.534-.219h12.5c.212 0 .39.071.534.214a.72.72 0 01.216.532c0 .21-.072.39-.216.535a.72.72 0 01-.534.219H3.75zm0-3.75a.728.728 0 01-.534-.214A.72.72 0 013 6.254c0-.21.072-.39.216-.535A.72.72 0 013.75 5.5h12.5c.212 0 .39.071.534.214a.72.72 0 01.216.532c0 .21-.072.39-.216.535A.72.72 0 0116.25 7H3.75z"
            fill="currentColor"
          />
        </>
      ),
    },
  },
  false
);

export default MenuIcon;
